module.exports = __webpack_public_path__ + "img/figure-17.3361ddb2.png";